import { useEffect, useState } from "react";

export const useWindowFocused = () => {
  const [isFocused, setIsFocused] = useState(document.visibilityState === "visible" && document.hasFocus());

  useEffect(() => {
    const update = () => {
      setIsFocused(document.visibilityState === "visible" && document.hasFocus());
    };

    window.addEventListener("focus", update);
    window.addEventListener("blur", update);
    document.addEventListener("visibilitychange", update);

    return () => {
      window.removeEventListener("focus", update);
      window.removeEventListener("blur", update);
      document.removeEventListener("visibilitychange", update);
    };
  }, []);

  return isFocused;
};
